// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"8f7d4e3d","213":"45cbb6d8","239":"b55beab3","455":"26b99030","669":"4b4e61f9","950":"a2204b95"}[chunkId] + ".chunk.js";
};